import ComponentType from "@/enums/ComponentType";
import FieldType from "@/enums/FieldType";

const Heading = {
  type: ComponentType.HEADING,
  name: "heading",
  settings: {
    value: {
      type: FieldType.STRING
    }
  }
};

export default Heading;